// extracted by css-extract-rspack-plugin
export default {"tooltipContent":"SA9yYXUeokgW3fak"};